// src/App.js
import React from 'react';
import {
  ThemeProvider,
  CssBaseline,
  Container,
  Box,
  Typography,
  Button,
  Grid,
  keyframes,
  Fade,
  useTheme,
  IconButton,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import { FiArrowUpRight, FiCheckCircle } from 'react-icons/fi';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';
import CountUp from 'react-countup';
import darkTheme from './theme';
import Header from './Header';
import DocsRoutes from './docs/DocsRoutes';
import AboutCrowdlaunch from './AboutCrowdlaunch';
import SignUp from './SignUp';
import { FiInstagram } from 'react-icons/fi';
import { FaTelegram, FaXTwitter } from 'react-icons/fa6';
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import FlippableCard from './FlippableCard';
import Blog from './Blog';
import BlogArticle from './BlogArticle';





const float = keyframes`
  0% { transform: translateY(0px) rotate(-5deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(-5deg); }
`;

const gradientBackground = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

function LandingPage() {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const { ref: headlineRef, inView: headlineInView } = useInView({ threshold: 0.1, triggerOnce: true });
  const { ref: featuresRef, inView: featuresInView } = useInView({ threshold: 0.1 });
  const { ref: statsRef, inView: statsInView } = useInView({ threshold: 0.1 });
  const { ref: ctaRef, inView: ctaInView } = useInView({ threshold: 0.1 });
  

  const heroStats = [
    { value: '67', label: 'Holders'},
    { value: 'BNB', label: 'Blockchain Network'},
    { value: 'BscScan', label: 'Verified On' },
  ];

 // Example features data (each object includes 'moreInfo' for the flip side)
const features = [
  {
    title: "Project Tokenization",
    description: "Tokenize your ideas, business, or start your own crypto project. Tokenization allows your project to become tradable for fractional ownership. ",
    moreInfo: "On CrowdLaunch, you can turn your idea, business, or project into digital shares that you can use to drive your idea through equity crowdfunding. Shareholders can in return be rewarded by the project creators with dividends for holding shares. "
  },
  {
    title: "Staking",
    description: "Stake your $LNCH in three different pools and earn dividends based on our platform transaction rate.",
    moreInfo: "LaunchToken stakers receive a share from our platform transactions. There are three different pools. Each pool has different conditions but receives a different percentage of dividends. "
  },
  {
    title: "Marketplace",
    description: "Support projects in early development. Buy and trade your digital shares with others in an open peer to peer market.  ",
    moreInfo: "View and interact with new projects. You can find and buy projects in their early phase as well as list your digital shares in an open peer to peer market."
  },
  {
    title: "Quests",
    description: "Join and complete a variety of tasks to receive $LNCH rewards.",
    moreInfo: "We regularly update our quests with new rewards and tasks. Keep completing and earning extra $LNCH for your part in supporting our early development. "
  }
  
];

// Group features into pairs (each group equals one slide)
const groupedFeatures = features.reduce((acc, curr, idx) => {
  if (idx % 1 === 0) {
    acc.push([curr]);
  } else {
    acc[acc.length - 1].push(curr);
  }
  return acc;
}, []);

// Minimal arrow components using Unicode symbols
const NextArrow = (props) => {
  const { onClick } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      onClick={onClick}
      sx={{
        position: 'absolute',
        right: isMobile ? "-7px" : "13px", // closer on mobile, further on desktop
        top: "50%",
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        color: '#FFD700',
        fontSize: isMobile ? '1.5rem' : '2rem',
        zIndex: 2,
      }}
    >
      ►
    </Box>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      onClick={onClick}
      sx={{
        position: 'absolute',
        left: isMobile ? "-7px" : "-30px", // closer on mobile, further on desktop
        top: "50%",
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        color: '#FFD700',
        fontSize: isMobile ? '1.5rem' : '2rem',
        zIndex: 2,
      }}
    >
      ◄
    </Box>
  );
};

// Modified slider settings for mobile
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "15px",
        dots: false,
      },
    },
  ],
};



  const economyStats = [
        { value: 50, label: "Early Project Funders", suffix: "+" },
        { value: 20, label: " Projects Onboarded", suffix: "+" },
        { value: 300, label: "LaunchToken Holders",  suffix: "+" },
        { value: 150, label: "Beta Testers", suffix: "+" },
    ];

    
    
    <Helmet>
  <title>CrowdLaunch Website</title>
  <meta name="CrowdLaunch Website" content="DeFi Project Tokenization" />
  <script async src="https://www.googletagmanager.com/gtag/js?id=G-W97PQD73RV"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-W97PQD73RV', { page_path: window.location.pathname });
    `}
  </script>
</Helmet>

// Track page view on component mount.
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-W97PQD73RV', {
        page_path: window.location.pathname,
      });
    }
  }, []);

  return (
    <Box sx={{ overflowX: 'hidden' }}>
      {/* Original Hero Section */}
      <Box sx={{
        minHeight: '85vh',
        position: 'relative',
        background: `
          linear-gradient(
            45deg,
            ${darkTheme.palette.background.default} 0%,
            ${darkTheme.palette.background.paper} 100%
          )
        `,
      }}>
        <Particles
          init={particlesInit}
          options={{
            particles: {
              number: { value: 50 },
              color: { value: darkTheme.palette.primary.main },
              opacity: { value: 0.3 },
              size: { value: 1 },
              move: { enable: true, speed: 1 }
            }
          }}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
          }}
        />

        <Container maxWidth="xl" sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          py: 4,
          position: 'relative'
        }}>
          <Box sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            height: '100%'
          }}>
            {/* Content Column */}
            <Box sx={{
              marginLeft: { xs: "auto", md: "50px" },
              marginTop: { xs: "auto", md: "90px" },
              flex: 1,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              pb: 4
            }}>
              <Fade in={headlineInView} timeout={1000}>
                <Box ref={headlineRef}>
                  <Typography variant="h1" sx={{
                    fontWeight: 900,
                    fontSize: { xs: '2rem', md: '3.5rem' },
                    lineHeight: 1.1,
                    mb: 3,
                    background: "#FFD700",
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                  }}>
                    Have an Idea?
                    <Box component="span" sx={{ 
                      display: 'block', 
                      fontSize: '0.8em',
                      mt: 1
                    }}>
                      Tokenize it.
                    </Box>
                  </Typography>

                  <Typography variant="h6" sx={{
                    mb: 4,
                    color: 'text.secondary',
                    fontSize: { xs: '1rem', md: '1.1rem' }
                  }}>
                    Tokenize your projects, stake $LNCH, and access community-driven funding.
                    Discover a new way to launch, manage, and grow your project with transparency and efficiency.
                  </Typography>

                  {/* Button Group */}
  <Button
    variant="contained"
    size="large"
    onClick={() => window.open('https://app.crowdlaunch.xyz', '_blank')}
    endIcon={<FiArrowUpRight />}
    sx={{
      px: 5,
      py: 1.5,
      fontWeight: 700,
      borderRadius: '50px',
      background: "#FFD700",
      color: "black",
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 24px rgba(255, 215, 0, 0.5)',
        background: "#FFC107",
      },
    }}
  >
    Launch Dapp
  </Button>



                  {/* Trust Section */}
                  <Box sx={{ mt: 4, opacity: 0.8 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                      Verified on BscScan – All associated contracts are audited.
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <img
                        src="https://brokepiggytoken.xyz/wp-content/uploads/2025/05/bnb-bnb-logo.png"
                        alt="BNB Smart Chain"
                        style={{ height: '28px' }}
                      />
                      <Typography variant="body2">
                        <span style={{ color: '#FFFFFF' }}>deployed on </span>
                        <span style={{ color: '#FFD700' }}>BNB Smart Chain</span>
                      </Typography>
                    </Box>
                  </Box>

                  {/* Original Stats Grid */}
                  <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
                    gap: 2,
                    mt: 4,
                    maxWidth: '600px'
                  }}>
                    {heroStats.map((stat, index) => (
                      <Fade key={index} in={headlineInView} timeout={800}>
                        <Box sx={{
                          p: 2,
                          borderRadius: '12px',
                          background: 'rgba(255,255,255,0.03)',
                          border: '1px solid rgba(255,255,255,0.1)'
                        }}>
                          <Typography variant="h4" sx={{
                            fontWeight: 800,
                            background: "#FFD700",
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            mb: 0.5
                          }}>
                            {stat.value}
                          </Typography>
                          <Typography variant="body2" sx={{ 
                            color: stat.label === "BscScan" ? "#FFFFFF" : "text.secondary",
                            fontSize: '0.9rem'
                          }}>
                            {stat.label}
                          </Typography>
                        </Box>
                      </Fade>
                    ))}
                  </Box>
                </Box>
              </Fade>
            </Box>

            {/* 3D Asset Column */}
            <Box sx={{
              flex: 1,
              height: '100%',
              display: { xs: 'none', lg: 'flex' },
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative'
            }}>
              <Box sx={{
                animation: `${float} 8s ease-in-out infinite`,
                maxWidth: '500px',
                width: '100%',
                '& img': {
                  width: '100%',
                  height: 'auto',
                  filter: 'drop-shadow(0 24px 48px rgba(255, 215, 0, 0.2))'
                }
              }}>
                <img
                  src="https://brokepiggytoken.xyz/wp-content/uploads/2025/05/lnch-logo-gif.gif"
                  alt="Platform Visualization"
                />
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>

{/* Added Features Section */}
<Box sx={{ py: 10, background: darkTheme.palette.background.paper }}>
  <Container maxWidth="xl">
    <Fade in={featuresInView} timeout={800}>
      <Box
        ref={featuresRef}
        sx={{
          // On desktop: 30% for title, 70% for slider; stacks on mobile.
          display: 'grid',
          gridTemplateColumns: { xs: '100%', md: '30% 70%' },
          gap: 4,
          alignItems: 'center',
        }}
      >
        {/* Left Column: Title */}
        <Box sx={{ pl: { xs: 4, md: 8 }, pt: { xs: 2, md: 1 } }}>
          <Typography 
            variant="h3" 
            sx={{
              textAlign: 'left',
              fontWeight: 600, // lighter weight
              background: "#FFD700",
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontSize: { xs: '1.5rem', md: '2.3rem' } // original desktop sizes
            }}
          >
            Explore CrowdLaunch
          </Typography>
        </Box>

        {/* Right Column: Two-Card Swiper */}
        <Box
  sx={{ 
    position: 'relative', 
    overflow: 'visible', 
    pr: { xs: 0, md: "40px" }, 
    display: { xs: "flex", md: "block" }, // use flex on mobile for centering
    justifyContent: { xs: 'center', md: 'inherit' },
    width: '100%' 
  }}
>
  <Slider {...sliderSettings} style={{ width: "100%" }}>
    {groupedFeatures.map((group, groupIndex) => (
      <Box
        key={groupIndex}
        sx={{
          marginTop: '20px',
          display: { xs: 'flex', md: 'grid' },
          flexDirection: { xs: 'column', md: undefined },
          gridTemplateColumns: { md: 'repeat(2, 40%)' },
          gap: 2,
          justifyContent: 'center',
          alignItems: 'center',
          mx: 'auto',
          minHeight: '350px'
        }}
      >
        {group.map((feature, index) => (
          <Box
            key={index}
            sx={{ 
              width: '100%',
              height: '300px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'visible',
              position: 'relative'
            }}
          >
            <FlippableCard feature={feature} darkTheme={darkTheme} />
          </Box>
        ))}
      </Box>
    ))}
  </Slider>
</Box>

      </Box>
    </Fade>
  </Container>
</Box>



      {/* Added Stats Section */}
<Box sx={{ 
  py: 10,
  background: `linear-gradient(135deg, ${darkTheme.palette.background.default} 0%, #1a1a2e 100%)`,
  position: 'relative'
}}>
  <Container maxWidth="xl">
    <Fade in={statsInView} timeout={800}>
      <Box ref={statsRef}>
        <Grid container spacing={6} alignItems="center">
          {/* Left Column: Text, Title, and Button */}
          <Grid item xs={12} md={6}>
            <Typography 
              variant="h3" 
              sx={{
                marginLeft: { xs: "auto", md: "50px" },
                mb: 2,
                fontWeight: 600,
                background: "#FFD700",
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: { xs: '1.8rem', md: '2.3rem' }
              }}
            >
              Our Next Targets
            </Typography>
            <Typography 
              variant="body1" 
              sx={{
                marginLeft: { xs: "auto", md: "50px" },
                mb: 3,
                marginTop: "10px",
                color: 'text.secondary',
                fontSize: { xs: '1rem', md: '1.2rem' },
                maxWidth: '500px'
              }}
            >
              We are excited to outline our roadmap for the near future. Our next targets focus on rapidly growing our community, onboarding innovative projects, and enhancing our platform’s capabilities. Discover more about our vision in our comprehensive whitepaper.
            </Typography>
            <Box sx={{ marginLeft: { xs: "auto", md: "50px" } }}>
            <Button
  variant="contained"
  size="large"
  onClick={() => window.open('https://crowdlaunch.xyz/docs/whitepaper', '_blank')}
  sx={{
    px: 5,
    py: 1.5,
    marginTop: "10px",
    fontWeight: 700,
    borderRadius: '50px',
    background: darkTheme.palette.background.default,
    color: darkTheme.palette.primary.main,
    border: '0.1px solid #FFD700',  // Added faint gold border
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
    }
  }}
>
  Read Whitepaper
</Button>

            </Box>
          </Grid>

          {/* Right Column: Stats */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {economyStats.map((stat, index) => (
                <Grid item xs={6} key={index}>
                  <Box
                    sx={{
                      p: 3,
                      borderRadius: '16px',
                      background: 'rgba(255,215,0,0.03)',
                      border: '1px solid rgba(255,215,0,0.1)'
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 800,
                        mb: 1,
                        color: darkTheme.palette.primary.main,
                        fontSize: { xs: '2rem', md: '3rem' },
                      }}
                    >
                      <CountUp end={stat.value} suffix={stat.suffix || ''} duration={2.5} />
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      {stat.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Fade>
  </Container>
</Box>


      {/* Added CTA Section */}
      <Box sx={{ 
        py: 15,
        background: "#FFD700",
        animation: `${gradientBackground} 15s ease infinite`,
        backgroundSize: '400% 400%'
      }}>
        <Container maxWidth="xl">
          <Fade in={ctaInView} timeout={800}>
          <Box ref={ctaRef} sx={{ textAlign: 'center' }}>
          <Typography 
  variant="h2" 
  sx={{ 
    mb: 4,
    fontWeight: 600,
    color: "#000", // Keep text black
    fontSize: { xs: '1.8rem', md: '2.7rem' } // Responsive font size
  }}
>
  Join the CrowdLaunch Eco-system
</Typography>

  
<Typography 
  variant="h5" 
  sx={{ 
    mb: 6,
    color: "#000", // Keep text black
    maxWidth: '800px',
    mx: 'auto',
    fontSize: { xs: '1rem', md: '1.3rem' } // Responsive font size
  }}
>
  Be one of the first on our platform. Tokenize your own idea, Stake your LaunchTokens, or fund a community project in its development. CrowdLaunch Beta is now open for all. 
</Typography>

<Button
  variant="contained"
  size="large"
  onClick={() => window.open('https://app.crowdlaunch.xyz', '_blank')}
  sx={{
    px: 8,
    py: 2,
    borderRadius: '50px',
    background: darkTheme.palette.background.default,
    color: darkTheme.palette.primary.main,
    fontWeight: 700,
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
    }
  }}
>
  Launch DApp
</Button>

</Box>

          </Fade>
        </Container>
      </Box>
      <Box
      sx={{
        background: darkTheme.palette.background.default,
        py: 4,
        borderTop: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          textAlign: { xs: 'center', md: 'left' },
        }}
      >
        {/* Left Side: Logo & Copyright */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <img
            src="https://brokepiggytoken.xyz/wp-content/uploads/2025/05/crowdlaunch-logo-white.png"
            alt="CrowdLaunch Logo"
            style={{ height: '50px' }}
          />
          <Typography
            variant="body2"
            sx={{ color: 'rgba(255,255,255,0.7)', fontSize: { xs: '0.8rem', md: '1rem' } }}
          >
            © 2025 CrowdLaunch. All Rights Reserved.
          </Typography>
        </Box>

        {/* Right Side: Social Icons */}
        <Box sx={{ display: 'flex', gap: 2, mt: { xs: 2, md: 0 } }}>
          <IconButton 
            component="a" 
            href="https://t.me/brokepiggy" 
            target="_blank"
            sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#0088cc' } }}
          >
            <FaTelegram size={22} />
          </IconButton>
          <IconButton 
            component="a" 
            href="https://twitter.com/PGGYOFFICIAL}" 
            target="_blank"
            sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#FFFFFF' } }}
          >
            <FaXTwitter size={22} />
          </IconButton>
          <IconButton 
            component="a" 
            href="https://www.instagram.com/crowdlaunch.xyz/" 
            target="_blank"
            sx={{ color: 'rgba(255,255,255,0.7)', '&:hover': { color: '#E4405F' } }}
          >
            <FiInstagram size={22} />
          </IconButton>
        </Box>
      </Container>
    </Box>
    </Box>
    
  );
  
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Header />
        <Routes>
          <Route path="/about/*" element={<AboutCrowdlaunch />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/docs/*" element={<DocsRoutes />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />


        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;